<template>
  <div class="my-form">
    <img class="close" @click="$emit('hideCover')" src="../assets/images/onepage/close.png" alt="">
    <h1>尊享试驾</h1>
    <!-- 横屏 -->
    <div v-if="!isPortrait" class="info">
      <el-form :inline="true" class="demo-form-inline" :model="driveForm" ref="driveForm">
        <el-row :gutter="20" v-if="alldata">
          <el-col :span="6">
            <el-form-item label="所在地">
              <el-select
                v-model="driveForm.Province"
                placeholder="选择省份"
                @change="setProvince"
              >
                <el-option
                  v-for="(item, key) in alldata.province"
                  :value="item.id"
                  :key="key"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item style="margin-top: 40px">
              <el-select
                v-model="driveForm.City"
                placeholder="选择城市"
                @click="setCity()"
                code-stm="event, PAGEURL, 切换城市信息pc"
                @change="cityChange"
              >
                <el-option
                  v-for="(item, key) in this.cascadingCities"
                  :value="item.id"
                  :key="key"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经销商">
              <el-select
                v-model="driveForm.DealerCode"
                placeholder="经销商"
                @change="dealerChange"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="carAlldata">
          <el-col :span="12" class="selectcar">
            <el-form-item label="车型">
              <el-select
                v-model="driveForm.CarSeriesCMSID"
                placeholder="请选择车型"
                @change="setCarSeries"
              >
                <el-option
                  v-for="(item, key) in carAlldata.series"
                  :key="key"
                  :value="item.cmsid"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="购车人信息">
              <span class="inline-txt">姓名</span>
              <el-input
                v-model="driveForm.Name"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 30px">
          <el-col :span="12">
            <el-form-item>
              <span class="inline-txt">手机号</span>
              <el-input
                v-model="driveForm.Phone"
                placeholder="请输入手机号"
                maxlength="11"
                oninput="if(value.length > 11) value=value.slice(0, 11)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="inline-txt">验证码</span>
              <el-input
                placeholder="请输入验证码"
                class="input"
                type="text"
                v-model="driveForm.Code"
                style="display: inline-block; width: 60%"
                maxlength="6"
                oninput="if(value.length > 6) value=value.slice(0, 6)"
              />
              <el-button
                class="button"
                @click="countDown()"
                code-stm="event, PAGEURL, 获取验证码pc"
                :class="{ disabled: !this.countDownCanClick }"
                style="display: inline-block; width: 40%"
                >{{ countDownContent }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-checkbox
            v-model="driveForm.checked"
            className="agreement-checkbox"
          >
            <span>
              *我同意起亚及合作商就购买新车事宜与我联系我同意提供电话号码
            </span>
          </el-checkbox>
        </el-row>
        <span class="submit-button"  @click="submitInformation"
              code-stm="event, PAGEURL, 提交预约试驾表单信息pc">提交信息</span>
      </el-form>
    </div>
    <!-- 竖屏 -->
    <div v-else class="info" :class="{'info-safari': isSafari}">
      <el-form :inline="true" class="demo-form-inline" :model="driveForm" ref="driveForm">
        <el-row v-if="alldata">
          <el-form-item label="所在地">
            <el-select
              v-model="driveForm.Province"
              placeholder="省份"
              @change="setProvince"
            >
              <el-option
                v-for="(item, key) in alldata.province"
                :value="item.id"
                :key="key"
                :label="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <el-select
              v-model="driveForm.City"
              placeholder="城市"
              @click="setCity()"
              code-stm="event, PAGEURL, 切换城市信息mob"
              @change="cityChange"
            >
              <el-option
                v-for="(item, key) in this.cascadingCities"
                :value="item.id"
                :key="key"
                :label="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="经销商">
              <el-select
                v-model="driveForm.DealerCode"
                placeholder="经销商"
                @change="dealerChange"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="carAlldata">
          <el-col :span="24" class="selectcar">
            <el-form-item label="车型">
              <el-select
                v-model="driveForm.CarSeriesCMSID"
                placeholder="请选择车型"
                @change="setCarSeries"
              >
                <el-option
                  v-for="item in carAlldata.series"
                  :key="item.name"
                  :value="item.cmsid"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="购车人信息">
            <span class="inline-txt">姓名</span>
            <el-input
              v-model="driveForm.Name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <span class="inline-txt">手机号</span>
            <el-input
              v-model="driveForm.Phone"
              placeholder="请输入手机号"
              maxlength="11"
              oninput="if(value.length > 11) value=value.slice(0, 11)"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <span class="inline-txt">验证码</span>
            <el-col :span="12">
              <el-input
                placeholder="请输入验证码"
                class="input"
                v-model="driveForm.Code"
                maxlength="6"
                oninput="if(value.length > 6) value=value.slice(0, 6)"
              />
            </el-col>
            <el-col :span="12">
              <el-button
                class="button"
                @click="countDown()"
                code-stm="event, PAGEURL, 获取验证码mob"
                :class="{ disabled: !this.countDownCanClick }"
                >{{ countDownContent }}</el-button
              >
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-checkbox
            v-model="driveForm.checked"
            className="agreement-checkbox"
          >
            <span>
              *我同意起亚及合作商就购买新车事宜与我联系我同意提供电话号码
            </span>
          </el-checkbox>
        </el-row>
        <span class="submit-button"  @click="submitInformation"
              code-stm="event, PAGEURL, 提交预约试驾表单信息mob">提交信息</span>
      </el-form>
    </div>
  </div>
</template>

<script>
import {  getUrlKey,isPortraitFun, isSafariFun } from "@/utils/utils.js";
import { apiUrl, pcdUrl, CSMUrl } from "../config/base";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isSafari: isSafariFun(),
      alldata: null,
      carAlldata: null,

      carModelSeries: [],
      cascadingCities: [],
      cascadingDealers: [],
      // canCheck: false,
      totalTime: 60,
      countDownContent: "获取验证码",
      countDownCanClick: true,
      driveForm: {
        //试驾
        Phone: "",
        Name: "",
        Code: "",
        Province: "",
        City: "",
        CarSeriesCMSID: "",
        CarSeriesName: "",
        CarModelCMSID: "",
        CarModelName: "",
        DealerName: "",
        DealerCode: "",
        checked: false,
      },
    };
  },

  created: function () {
    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);

        this.alldata = res.data;
        this.initData();
      });
    }
    window.addEventListener("resize", this.setResize);
  },
  methods: {
    initData() {
      let that = this;
      this.$axios.get(CSMUrl).then((res) => {
        console.log("车型车款数据", res.data);
        that.carAlldata = res.data;
      });
    },

    setResize() {
      // console.log(13123, this.isPortrait);
      this.isPortrait = isPortraitFun();
    },
    setProvince() {
      this.driveForm.City = "";
      this.setCity();
    },
    setCity() {
      // this.cascadingCities = this.alldata.city[this.driveForm.Province];
      this.cascadingCities = [];
      this.alldata.city[this.driveForm.Province].forEach((cityIter) => {
        //过滤city
        if (
          this.alldata.cityRelType[cityIter.id].includes("1") ||
          this.alldata.cityRelType[cityIter.id].includes("4")
        ) {
          this.cascadingCities.push(cityIter);
        }
      });
      this.driveForm.City = this.driveForm.City || this.cascadingCities[0].id;
      this.cityChange(this.driveForm.City);
    },

    setCarSeries() {
      this.driveForm.CarModelCMSID = "";
      console.log(
        "this.driveForm.CarSeriesCMSID",
        this.driveForm.CarSeriesCMSID
      );
      if(this.driveForm.CarSeriesCMSID){
        this.driveForm.CarModelCMSID = this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).cmsid;
        this.driveForm.CarModelName = this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).name;
      }
      console.log('this.driveForm.CarModelName',this.driveForm.CarModelName);
    },
    cityChange(cityId) {
      //改变经销商数据/起点
      let temp = this.alldata.dealer[cityId];
      this.cascadingDealers = [];
      temp.forEach((origin) => {
        if (origin.type == "1" || origin.type == "4") {
          this.cascadingDealers.push(origin);
        }
      });
      this.driveForm.DealerCode = this.cascadingDealers[0].code;
      this.driveForm.DealerName = this.cascadingDealers[0].name;
    },
    dealerChange(dealerCode) {
      let dealer = this.cascadingDealers.find((value) => {
        return value.code === dealerCode;
      });
      this.driveForm.DealerCode =
        dealer == null ? this.cascadingDealers[0].code : dealer.code;
      this.driveForm.DealerName =
        dealer == null ? this.cascadingDealers[0].name : dealer.name;
    },
    countDown() {
      if (!this.driveForm.Phone) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      if (!this.countDownCanClick) return; //改动的是这两行代码
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      var clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true; //这里重新开启
        }
      }, 1000);
      //发送验证码
      let getCodeData = {
        phoneNumbers: this.driveForm.Phone,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/sendVerificationCode`, getCodeData)
        .then((res) => {
          console.log("ressssssss", res);
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    submitInformation(){
       if (
        !this.driveForm.Name ||
        !this.driveForm.Phone ||
        !this.driveForm.Code ||
        !this.driveForm.CarSeriesCMSID
      ) {
        this.$message.error("请完善信息后再次提交");
        return;
      }
      //获取车型名字
      // console.log(this.carSeries)
      let CarSeriesName = this.carAlldata.series.find((item, index) => {
        return item.cmsid === this.driveForm.CarSeriesCMSID;
      });
      //获取默认经销商名字和编码
      if (!this.driveForm.DealerCode || !this.driveForm.DealerName) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
      //将省市转化成字符串
      let provinceStr = this.alldata.province.find(
        (item) => item.id === this.driveForm.Province
      );
      let cityStr = this.alldata.city[this.driveForm.Province].find(
        (item) => item.id === this.driveForm.City
      );
      provinceStr = provinceStr.name;
      cityStr = cityStr.name;

      if (!this.driveForm.checked) {
        this.$message.error("请先同意起亚及合作商就购买新车事宜与您联系您同意提供电话号码");
        return;
      }
      let subFormDrive = {
        //媒体来源、活动来源、媒体渠道ID没写
        carModelCmsid: this.driveForm.CarModelCMSID,
        carModelName: this.driveForm.CarModelName,
        carSeriesCmsid: this.driveForm.CarSeriesCMSID,
        carSeriesName: CarSeriesName.name,
        cityName: cityStr,
        dealerCode: this.driveForm.DealerCode,
        dealerName: this.driveForm.DealerName,
        provinceName: provinceStr,
        userName: this.driveForm.Name,
        userPhone: this.driveForm.Phone,
        verificationCode: this.driveForm.Code,
        smartCode: getUrlKey("utm_source") || "官网", //媒体来源
        activity: getUrlKey("utm_activity") || "EV5新车上市落地页", //活动名称
        extraSix: getUrlKey("utm_soid") || "76",
      };
      //预约试驾接口
      this.$axios.post(`${apiUrl}clue/australiaPage`,subFormDrive).then((res) => {
        console.log(99999998888,res);
        if (res.data.success) {
          this.$message.success("预约试驾成功");
          console.log(subFormDrive);
          setTimeout(() => {
            this.driveForm.CarModelCMSID="";
            this.driveForm.CarSeriesCMSID="";
            this.driveForm.DealerCode="";
            this.driveForm.DealerName="";
            this.driveForm.Name="";
            this.driveForm.Phone="";
            this.driveForm.Code="";
            this.driveForm.City="";
            this.driveForm.Province="";
            this.driveForm.checked = false;
          }, 1000);
        } else {
          this.$message.error("预约试驾失败:" + res.data.message);
          console.log(subFormDrive);
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-form {
  border-radius: 10px 10px 0 0;
  position: relative;
  background: #fff;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .close {
    position: absolute;
    top: 22px;
    right: 18px;
    width: 18px;
    height: auto;
    opacity: 1;
  }
  h1 {
    font-size: 38px;
    text-align: center;
    &::before {
      content: "—";
      margin-right: 12px;
    }
    &::after {
      content: "—";
      margin-left: 12px;
    }
  }

  .info {
    width: 100%;
    padding: 0 10% 20px;
    flex: 1;
    overflow-y: auto;
  }
  @media screen and (orientation: portrait) {
    .info {
      &-safari {
        padding-bottom: 100px;
      }
    }
    h1 {
      font-size: 30px;
      padding: 8% 0 0;
    }
    ::v-deep .el-input__inner {
      height: 42px;
      line-height: 42px;
      font-size: 12px;
    }
    .el-button {
      height: 42px;
    }
    .submit-button {
      font-size: 16px;
      padding: 4% 0;
    }
    .el-row {
      box-sizing: border-box;
      margin-top: 3%;
    }
    ::v-deep .el-form-item__content .inline-txt {
      position: absolute;
      line-height: 42px;
      padding: 0 10px;
      color: #3d3d3d;
    }
  }
}
.submit-button {
  width: 100%;
  display: block;
  text-align: center;
  background-color: #19191C;
  padding: 2% 0;
  color: #fff;
  font-size: 20px;
  margin-top: 2%;
}
.el-button {
  width: 100%;
  background: #19191C;
  border-radius: 0px;
  height: 50px;
  color: #fff;
  border: none;
}
::v-deep .el-checkbox__label span {
  display: block;
  color: #a7a7a7;
  margin-top: 15px;
  font-size: 12px;
}
::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #19191C, $alpha: 0.3);
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19191C;
  border-color: #19191C;
}
::v-deep .el-form-item {
  margin: 0;
  width: 100%;
}

::v-deep .el-form-item__content {
  width: 100%;
  .inline-txt {
    position: absolute;
    line-height: 50px;
    padding: 0 10px;
    color: #3d3d3d;
  }
}

::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    padding: 0 10px;
  }
}
::v-deep .el-input__inner {
  border-radius: 0px;
  height: 50px;
  padding-left: 60px;
  line-height: 50px;
  background: transparent;
  border: 1px solid rgba($color: #19191C, $alpha: 0.3)!important;
  color: #3d3d3d;
}
::v-deep .el-form--inline .el-form-item__label {
  display: block;
  text-align: left;
}
::v-deep .el-checkbox__input{
  vertical-align: top;
}
::v-deep .el-checkbox__label span {
  display: block;
  margin-top: 0px;
  white-space: pre-wrap;
}
</style>
